import cx from 'classnames'
import { useEffect, useRef } from 'react'
import Picker from '@emoji-mart/react'
import { Button } from 'components/Button'

import Styles from './TitleEmojiPicker.module.scss'
import { BaseEmoji } from 'types'
interface Props {
  onSelect: (emoji: BaseEmoji | null) => void
  disabled?: boolean
  removable?: boolean
  showEmojiPicker: boolean
  toggleShowEmojiPicker: () => void
  className?: string
}

const DocEmojiPicker = ({ onSelect, removable = false, showEmojiPicker, toggleShowEmojiPicker, className }: Props) => {
  const emojiPickerRef = useRef<HTMLDivElement>(null)

  const handleEmojiSelect = (emoji: any) => {
    onSelect(emoji)
  }

  useEffect(() => {
    const handleOutsideClick = (e: Event) => {
      if (emojiPickerRef.current?.contains(e.target as Node)) return
      if (showEmojiPicker) {
        toggleShowEmojiPicker()
      }
    }
    document.addEventListener('click', handleOutsideClick)

    return () => document.removeEventListener('click', handleOutsideClick)
  }, [emojiPickerRef, showEmojiPicker, toggleShowEmojiPicker])

  return (
    <div ref={emojiPickerRef} className={cx(Styles.emojiPicker, { [Styles.visible]: showEmojiPicker }, className)}>
      <Picker theme="light" onEmojiSelect={handleEmojiSelect} previewPosition="none" autoFocus />
      <div className={cx(Styles.bottomBar, { [Styles.visible]: showEmojiPicker })}>
        <Button isDisabled={!removable} onPress={() => onSelect(null)} size="sm" variant="secondaryGrey">
          Remove Emoji
        </Button>
      </div>
    </div>
  )
}

export default DocEmojiPicker
